"use client"

import { AppRouterCacheProvider as MuiAppRouterCacheProvider } from "@mui/material-nextjs/v15-appRouter"
import { ReactNode } from "react"
import { prefixer } from "stylis"
import rtlPlugin from "stylis-plugin-rtl"

/**
 * Client-side wrapper for Material UI's AppRouterCacheProvider with RTL support.
 *
 * This component configures Emotion cache with:
 * - RTL (right-to-left) support via stylis-plugin-rtl
 * - CSS layer wrapping for better specificity control with styled-components
 * - Proper SSR style injection via Next.js App Router
 *
 * The cache options must be defined in a client component because
 * stylis plugins are functions and cannot be serialized for RSC.
 */
export default function AppRouterCacheProvider({
  children,
}: {
  children: ReactNode
}) {
  return (
    <MuiAppRouterCacheProvider
      options={{
        key: "mui",
        stylisPlugins: [prefixer, rtlPlugin],
        prepend: true,
        enableCssLayer: true,
      }}
    >
      {children}
    </MuiAppRouterCacheProvider>
  )
}
